import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";

import { Header } from "./components/Header";
import { Hero } from "./components/Hero";
import { Ticker, LogoStrip } from "./components/Ticker";
import { Philosophy } from "./components/Philosophy";
import { Coach } from "./components/Coach";
import { Programs } from "./components/Programs";
import { Book } from "./components/Book";
import { Newsletter } from "./components/Newsletter";
import { Footer } from "./components/Footer";
import { ScrollToTop } from "./components/ScrollToTop";
import { BackToTop } from "./components/BackToTop";
import { InquiryModal } from "./components/InquiryModal";
import { InquiryProvider } from "./lib/InquiryContext";

import PhilosophyPage from "./pages/PhilosophyPage";
import ProgramsOverviewPage from "./pages/ProgramsOverviewPage";
import ProgramDetailPage from "./pages/ProgramDetailPage";
import CoachPage from "./pages/CoachPage";
import BookPage from "./pages/BookPage";
import ContactPage from "./pages/ContactPage";
import AboutPage from "./pages/AboutPage";
import LegalPage from "./pages/LegalPage";
import NotFoundPage from "./pages/NotFoundPage";
import { SiteJsonLd } from "./components/page/SiteJsonLd";
import { SkipNav } from "./components/a11y/SkipNav";
import { RouteTracker } from "./lib/analytics";

import { AuthProvider } from "./admin/AuthContext";
import { ProtectedRoute } from "./admin/ProtectedRoute";
import { AdminLayout } from "./admin/AdminLayout";
import { Login } from "./admin/Login";
import { Dashboard } from "./admin/Dashboard";
import { SectionEditor } from "./admin/SectionEditor";
import { Settings } from "./admin/Settings";
import { Programs as ProgramsAdmin } from "./admin/Programs";
import { Posts } from "./admin/Posts";
import { Inquiries } from "./admin/Inquiries";
import { Snapshot } from "./admin/Snapshot";

const Landing = () => (
  <div className="App bg-[#0a0a0a] text-white">
    <Header />
    <main id="main-content" tabIndex={-1} className="focus:outline-none">
      <Hero />
      <Ticker />
      <LogoStrip />
      <Philosophy />
      <Coach />
      <Programs />
      <Book />
      <Newsletter />
    </main>
    <Footer />
  </div>
);

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
          <InquiryProvider>
            <SkipNav />
            <RouteTracker />
            <ScrollToTop />
            <BackToTop />
            <InquiryModal />
            <SiteJsonLd />
            <Routes>
            <Route path="/" element={<Landing />} />
            <Route path="/philosophy" element={<PhilosophyPage />} />
            <Route path="/programs" element={<ProgramsOverviewPage />} />
            <Route path="/programs/:slug" element={<ProgramDetailPage />} />
            <Route path="/coach" element={<CoachPage />} />
            <Route path="/book" element={<BookPage />} />
            <Route path="/contact" element={<ContactPage />} />
            <Route path="/about" element={<AboutPage />} />
            <Route path="/privacy" element={<LegalPage sectionKey="page_privacy" canonical="/privacy" />} />
            <Route path="/terms" element={<LegalPage sectionKey="page_terms" canonical="/terms" />} />
            <Route path="/cookies" element={<LegalPage sectionKey="page_cookies" canonical="/cookies" />} />

            <Route path="/admin/login" element={<Login />} />
            <Route
              path="/admin"
              element={
                <ProtectedRoute>
                  <AdminLayout />
                </ProtectedRoute>
              }
            >
              <Route index element={<Dashboard />} />
              <Route path="content/:sectionKey" element={<SectionEditor />} />
              <Route path="programs" element={<ProgramsAdmin />} />
              <Route path="posts" element={<Posts />} />
              <Route path="inquiries" element={<Inquiries />} />
              <Route path="snapshot" element={<Snapshot />} />
              <Route path="settings" element={<Settings />} />
            </Route>
            <Route path="*" element={<NotFoundPage />} />
          </Routes>
          </InquiryProvider>
        </AuthProvider>
      </BrowserRouter>
      <Toaster
        position="bottom-right"
        theme="dark"
        toastOptions={{
          style: {
            background: "#141414",
            border: "1px solid #27272a",
            color: "#fff",
            borderRadius: "0",
          },
        }}
      />
    </div>
  );
}

export default App;
